import gql from 'graphql-tag';

export const CONVERT_GPA = gql`
  mutation ($digitToLetterRule: String, $courses: [MarkInput!]!) {
    convertGPA(
      input: { digitToLetterRule: $digitToLetterRule, courses: $courses }
    ) {
      convertedGPA
    }
  }
`;
